import { useI18n } from "../../lib/i18n.jsx";
import { Snowflake, Users, Wrench, Ruler, Wifi, Car, MapPin } from "lucide-react";
import Reveal from "../Reveal.jsx";

const ICONS = [Snowflake, Ruler, Users, Wrench, Wifi, Car];

export default function SkateparkSection() {
  const { t } = useI18n();
  const s = t.skatepark;
  return (
    <section id="skatepark" data-testid="skatepark-section" className="bg-paper py-20 md:py-28">
      <div className="max-w-[1300px] mx-auto px-5 md:px-8">
        <Reveal as="div" className="grid lg:grid-cols-12 gap-10 mb-10 items-end">
          <div className="lg:col-span-7">
            <p className="font-handwritten text-summer text-2xl md:text-3xl mb-2">{s.kicker}</p>
            <h2 className="font-display font-bold text-winter leading-tight" style={{ fontSize: "clamp(2rem, 4.5vw, 3.5rem)" }}>
              {s.title_1} <span className="font-handwritten text-summer text-[1.05em]">{s.title_2}</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-lg text-winter/70">{s.subtitle}</p>
          </div>
        </Reveal>

        <div className="relative aspect-[16/7] md:aspect-[21/8] rounded-3xl overflow-hidden mb-6">
          <img src="/img/skatepark.webp" alt="Skatepark AvePark" className="absolute inset-0 w-full h-full object-cover" />
          <a
            href="https://www.google.com/maps/dir//Skatepark+Ave%2FPark,+Krakowiak%C3%B3w,+02-255+Warszawa"
            target="_blank" rel="noopener noreferrer"
            className="absolute bottom-4 left-4 sticker bg-cream text-winter shadow-lg"
          >
            <MapPin className="w-3.5 h-3.5" /> {s.address}
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {s.features.map((f, i) => {
            const Icon = ICONS[i] || Snowflake;
            return (
              <div key={i} className="card-soft p-4 flex items-start gap-3" data-testid={`skatepark-feature-${i}`}>
                <div className="shrink-0 w-10 h-10 rounded-full bg-summer/10 flex items-center justify-center">
                  <Icon className="w-5 h-5 text-summer" />
                </div>
                <div>
                  <p className="font-display font-bold text-winter text-sm">{f.title}</p>
                  <p className="text-xs text-winter/60 mt-0.5">{f.body}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
